<template>
  <div class="PageMyReleaseOrder">
    <h2 class="includeBtn">{{ $t("pages.wording.myReleaseOrder") }}</h2>
    <!--我的放行單-->
    <el-form label-width="150px">
      <div class="boxContain c-form searchBar">
        <!--查詢放行單-->
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item :label="$t('pages.wording.releaseNo')"
              ><!--放行單號-->
              <el-input :placeholder="$t('pages.wording.releaseNo')" v-model.trim="searchForm.releaseNo"></el-input
              ><!--放行單號 v-model="searchForm.releaseNo"-->
            </el-form-item>
          </el-col>
          <el-col :span="11" style="max-width: 28em">
            <el-form-item :label="$t('pages.wording.salesDate')"
              ><!--出售日期-->
              <el-date-picker
                v-model="searchForm.applyDate"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button class="blue-button" @click="searchTable()" type="primary">{{
              $t("pages.button.search")
            }}</el-button
            ><!--查詢-->
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="boxContain c-table includeBtn delta_table">
      <el-tabs v-model="activeName">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.preProccess") }}({{
              preProcessTableData.length
            }})</span
          ><!--待處理-->
          <div class="s-table">
            <template>
              <el-table
                v-loading="loading"
                :data="preProcessNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyReleaseForm"
                @sort-change="PreProcessChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div v-if="!readOnly">
                      <el-button @click="releaseDelete(scope.row)" type="text" size="medium">
                        <i class="el-icon-delete"></i>
                      </el-button>
                      <el-button type="text" size="medium">
                        <i class="el-icon-edit"></i>
                      </el-button>
                    </div>
                    <div v-if="readOnly">
                      <el-button type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="125">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveTitle')" width="120">
                </el-table-column
                ><!--預約單-->
                <el-table-column prop="carPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" label="OA CODE" width="120"> </el-table-column
                ><!--OA CODE-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="160"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="reserveArriveDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                </el-table-column
                ><!--出售日期-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="100">
                </el-table-column
                ><!--台達填單人-->
                <el-table-column
                  prop="releaseOrderStatus"
                  label-class-name="header_label"
                  :label="$t('pages.wording.releaseOrderStatus')"
                  minWidth="70"
                  maxWidth="160"
                >
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
                <el-table-column prop="applyDate" :label="$t('pages.wording.releaseCreateDate')">
                  <template slot-scope="scope">
                    {{ scope.row.applyDate }}
                  </template></el-table-column
                ><!--開單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.preProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.preProcessTablePage.pageTotal"
              @current-change="changePagePreProcessTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table--> </el-tab-pane
        ><!--preProcess-->
        <el-tab-pane label="inProcess" name="second">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.inProccess") }}({{
              inProcessTableData.length
            }})</span
          ><!--處理中-->
          <div class="s-table">
            <template>
              <el-table
                :data="inProcessNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyReleaseForm"
                @sort-change="InProcessChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                    <el-button @click="releaseDelete(scope.row)" type="text" size="medium">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="125">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveTitle')" width="120">
                </el-table-column
                ><!--預約單-->
                <el-table-column prop="tmpCarPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" label="OA CODE" width="120"> </el-table-column
                ><!--OA CODE-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                </el-table-column
                ><!--出售日期-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="100">
                </el-table-column
                ><!--填單人-->
                <el-table-column
                  prop="releaseOrderStatus"
                  label-class-name="header_label"
                  :label="$t('pages.wording.releaseOrderStatus')"
                  minWidth="70"
                  maxWidth="160"
                >
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
                <el-table-column prop="applyDate" :label="$t('pages.wording.releaseCreateDate')">
                  <template slot-scope="scope">
                    {{ scope.row.applyDate }}
                  </template></el-table-column
                ><!--開單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.inProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.inProcessTablePage.pageTotal"
              @current-change="changePageInProcessTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table--> </el-tab-pane
        ><!--inProcess-->
        <el-tab-pane label="finish" name="third">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.finish") }}({{ finishTableData.length }})</span
          ><!--已完成-->
          <div class="s-table">
            <template>
              <el-table
                :data="finishNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyReleaseForm"
                @sort-change="FinishChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template>
                    <el-button type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="125">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveTitle')" width="120">
                </el-table-column
                ><!--預約單-->
                <el-table-column prop="tmpCarPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" label="OA CODE" width="120"> </el-table-column
                ><!--OA CODE-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                </el-table-column
                ><!--出售日期-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="100">
                </el-table-column
                ><!--台達填單人-->
                <el-table-column
                  prop="releaseOrderStatus"
                  label-class-name="header_label"
                  :label="$t('pages.wording.releaseOrderStatus')"
                  minWidth="70"
                  maxWidth="160"
                >
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
                <el-table-column prop="applyDate" :label="$t('pages.wording.releaseCreateDate')">
                  <template slot-scope="scope">
                    {{ scope.row.applyDate }}
                  </template> </el-table-column
                ><!--開單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.finishTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.finishTablePage.pageTotal"
              @current-change="changePageFinishTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table--> </el-tab-pane
        ><!--inProcess-->
      </el-tabs>
    </div>
    <!--boxContain-->
  </div>
  <!--pageMyReleaseOrder-->
</template>

<script>
import { role } from "@/config/role.js"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { mapGetters } from "vuex"
export default {
  name: "MyReleaseOrder",
  data() {
    return {
      readOnly: false,
      activeName: "first",
      searchForm: {
        releaseNo: "", //查詢預約單號
        applyDate: "",
      },
      preProcessTableData: [],
      preProcessNewTableData: [],
      inProcessTableData: [],
      inProcessNewTableData: [],
      finishTableData: [],
      finishNewTableData: [],
      pages: {
        pageCount: 5,
        pageSize: 20,
        preProcessTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
        inProcessTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
        finishTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
      },
      queryParamsAfterSubmit: {
        releaseNo: "", //查詢預約單號
        applyDate: "",
      },
      loading: false,
      user: {
        region: null,
        area: null,
        factory: null,
      },
      preTabName: "", //keep click tab name for go back action
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles"]),
    /***************-GENERAL-***************/
    init() {
      let vueInstance = this
      let userRoles = vueInstance.getUserRoles() ?? []
      this.user.region = this.getUserProfile().region
      this.user.area = this.getUserProfile().area
      this.user.factory = this.getUserProfile().factory

      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        vueInstance.readOnly = true
      }
      vueInstance.queryTable()
    },
    /***************-PAGING-***************/
    changePagePreProcessTable(val) {
      this.preProcessNewTableData = utils.buildPagingTable(this.preProcessTableData, val, this.pages.pageSize)
    },
    changePageInProcessTable(val) {
      this.inProcessNewTableData = utils.buildPagingTable(this.inProcessTableData, val, this.pages.pageSize)
    },
    changePageFinishTable(val) {
      this.finishNewTableData = utils.buildPagingTable(this.finishTableData, val, this.pages.pageSize)
    },
    PreProcessChangeSort(cols) {
      utils.sortChangeMethod(cols, this.preProcessTableData)
      this.preProcessNewTableData = utils.buildPagingTable(
        this.preProcessTableData,
        this.pages.preProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    InProcessChangeSort(cols) {
      utils.sortChangeMethod(cols, this.inProcessTableData)
      this.inProcessNewTableData = utils.buildPagingTable(
        this.inProcessTableData,
        this.pages.inProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    FinishChangeSort(cols) {
      utils.sortChangeMethod(cols, this.finishTableData)
      this.finishNewTableData = utils.buildPagingTable(
        this.finishTableData,
        this.pages.finishTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    /***************-FORM ACTIVE-***************/
    queryTable() {
      let userAD = this.getUserProfile().userAD
      let monthDate = utils.getMonthFirstLastDate()
      let firstDate = utils.getDateTime(monthDate[0])
      let lastDate = utils.getDateTime(monthDate[1])
      let firstDatetime = utils.getISOString(firstDate[0] + " " + firstDate[1])
      let lastDatetime = utils.getISOString(lastDate[0] + " " + lastDate[1])

      //deal with query setting after go back action
      let preQueryReleaseNo = ""
      if (window.sessionStorage.getItem("queryParams") !== null) {
        let queryParams = JSON.parse(window.sessionStorage.getItem("queryParams"))
        firstDatetime = utils.getISOString(utils.getDateTime(new Date(queryParams.applyDate[0]))[0] + " 00:00")
        lastDatetime = utils.getISOString(utils.getDateTime(new Date(queryParams.applyDate[1]))[0] + " 00:00")
        this.preTabName = queryParams.tabName
        preQueryReleaseNo = queryParams.releaseNo
        window.sessionStorage.removeItem("queryParams")
      }

      let parameter = {
        releaseOrderNo: preQueryReleaseNo,
        reserveAreaList: this.user.area,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
        reserveArriveDateTimeStart: firstDatetime,
        reserveArriveDateTimeEnd: lastDatetime, //SA要以進廠日期, 但ERP產生預約單沒有預約進廠日期 會查不到
      }
      this.loading = true
      this.$store.dispatch("getReleaseTable", parameter)

      //查詢預設
      this.searchForm.applyDate = [utils.parseISOStringToDate(firstDatetime), utils.parseISOStringToDate(lastDatetime)]
      this.searchForm.releaseNo = preQueryReleaseNo
      //keep query parameters after submit query
      this.queryParamsAfterSubmit.releaseNo = this.searchForm.releaseNo
      this.queryParamsAfterSubmit.applyDate = this.searchForm.applyDate
    },
    searchTable() {
      let userAD = this.getUserProfile().userAD
      let parameter = {
        reserveAreaList: this.user.area,
        releaseOrderStatus: ["cancel", "NEW", "sign", "in1", "in2", "finished"],
        releaseOrderNo: this.searchForm.releaseNo,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
      }

      if (this.searchForm.applyDate != null && this.searchForm.applyDate.length != 0) {
        parameter.reserveArriveDateTimeStart = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.applyDate[0]))[0] + " 00:00"
        )
        parameter.reserveArriveDateTimeEnd = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.applyDate[1]))[0] + " 23:59"
        )
      }
      //keep query parameters after submit query
      this.queryParamsAfterSubmit.releaseNo = this.searchForm.releaseNo
      this.queryParamsAfterSubmit.applyDate = this.searchForm.applyDate
      this.loading = true
      this.$store.dispatch("getReleaseTable", parameter)
    },
    releaseDelete(row) {
      let vm = this
      let e = window.event
      e.stopPropagation()
      let vueInstance = this
      vueInstance
        .$confirm(vueInstance.$t("pages.button.confirmcancelrelease"))
        .then((_) => {
          utils.showLoading(vm)
          let params = {
            reserveID: row.reserveRef,
            releaseID: row.id,
          }
          api
            .apiCancelReleaseData(params)
            .then((response) => {
              utils.closeLoading(vm)
              if (response.data.success) {
                vueInstance.$message({
                  message: vueInstance.$t("message.alert.successCancel"),
                  type: "success",
                })
                vueInstance.queryTable()
              } else {
                utils.alertMessage(vueInstance, 1, response.data.messageCode)
              }
            })
            .catch(function (e) {
              utils.closeLoading(vm)
              utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.failCancel"))
            })
        })
        .catch((_) => {})
    },
    applyReleaseForm(val) {
      //keep params of query for go back.
      let queryparams = {
        applyDate: this.queryParamsAfterSubmit.applyDate,
        releaseNo: this.queryParamsAfterSubmit.releaseNo,
        tabName: this.activeName,
      }
      let prevPageParams = {
        routeName: "PageMyReleaseOrder",
        key: {},
      }
      val["queryParams"] = queryparams
      val["prevPageParams"] = prevPageParams
      this.$router.push({
        name: "PageMyReleaseOrderForm",
        params: val,
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      let code = val.code
      let message = val.message
      let cb = val.cb
      let title = code == 0 ? "success" : "fail"

      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.storeCallback": function (val) {
      val.fn()
    },
    "$store.getters.releaseTable": function (datas) {
      if (datas.length <= 0) {
        this.finishNewTableData = []
        this.preProcessNewTableData = []
        this.inProcessNewTableData = []
        this.finishTableData = []
        this.preProcessTableData = []
        this.inProcessTableData = []
      } else {
        this.finishTableData = []
        this.preProcessTableData = []
        this.inProcessTableData = []

        datas.forEach((item) => {
          switch (item.releaseOrderStatus) {
            case "NEW":
              //item.showStatus = '暫存'
              this.preProcessTableData.push(item)
              break
            case "sign":
            case "in1":
            case "in2": //復檢站
              this.inProcessTableData.push(item)
              break
            case "finished":
            case "cancel":
              this.finishTableData.push(item)
              break
          }
        })
        this.pages.preProcessTablePage.pageTotal = this.preProcessTableData.length
        this.preProcessNewTableData = utils.buildPagingTable(
          this.preProcessTableData,
          this.pages.preProcessTablePage.pageCurrent,
          this.pages.pageSize
        )

        this.pages.inProcessTablePage.pageTotal = this.inProcessTableData.length
        this.inProcessNewTableData = utils.buildPagingTable(
          this.inProcessTableData,
          this.pages.inProcessTablePage.pageCurrent,
          this.pages.pageSize
        )

        this.pages.finishTablePage.pageTotal = this.finishTableData.length
        this.finishNewTableData = utils.buildPagingTable(
          this.finishTableData,
          this.pages.finishTablePage.pageCurrent,
          this.pages.pageSize
        )
      }
      this.loading = false
      //select tab after click go back from Form page
      if (this.preTabName !== "") {
        this.activeName = this.preTabName
        this.preTabName = ""
      }
    },
  },
}
</script>

<style>
.body .searchBar.c-form .el-row {
  line-height: normal;
}
</style>
